/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Tim_CtaInputs */

const en_cp_p_tim_cta = /** @type {(inputs: Cp_P_Tim_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start now`)
};

const id_cp_p_tim_cta = /** @type {(inputs: Cp_P_Tim_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai sekarang`)
};

/**
* | output |
* | --- |
* | "Start now" |
*
* @param {Cp_P_Tim_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_tim_cta = /** @type {((inputs?: Cp_P_Tim_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Tim_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_tim_cta(inputs)
	return en_cp_p_tim_cta(inputs)
});